import React, { useCallback, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import {
  Box,
  Text,
  CloudinaryImage,
  Inline,
  Stack,
} from '@stitch-fix/mode-react';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';
import './styles.module.scss';
import StyleQuizModal from '../StyleQuizModal';

/**
 * Renders the New Entry Points for men and women's business lines
 */
const NewEntryPoints = () => {
  const [state, dispatch] = useProductDetailsPageContext();

  const [newEntryPointsInViewRef, newEntryPointsInView] = useInView({
    triggerOnce: true,
  });

  const setNewEntryPointsRefs = useCallback(
    node => {
      newEntryPointsInViewRef(node);
    },
    [newEntryPointsInViewRef],
  );

  useEffect(() => {
    if (newEntryPointsInView) {
      dispatch({ type: 'NEW_ENTRY_POINTS_CARD_VIEWED' });
    }
  }, [newEntryPointsInView, dispatch]);

  const mediaPath =
    state.productBusinessLine === 'WOMENS'
      ? 'v1665083138/new-entry-points/womens-fix-pdp-card.png'
      : 'v1666040061/new-entry-points/mens-fix-pdp-card.jpg';

  const headlineText =
    state.productBusinessLine === 'WOMENS'
      ? 'Ready to collaborate?'
      : 'Need a little fashion help?';

  const bodyText =
    state.productBusinessLine === 'WOMENS'
      ? 'Your new stylist is here to help you find one-of-a-kind faves.'
      : 'Let our style experts curate looks for your style, fit and budget.';

  return (
    <div ref={setNewEntryPointsRefs}>
      <Box bgColor="gray-99" styleName="new-entry-points" p={1}>
        <Inline spacing={1.5} vAlign="center" pt={0.5} pb={0.5}>
          <div styleName="new-entry-points-picture">
            <CloudinaryImage
              alt=""
              baseUrl="https://res.cloudinary.com/stitch-fix/image/upload/"
              mediaPath={mediaPath}
              sizes={{
                sm: 200,
              }}
              objectFit="cover"
              objectPosition="none"
            />
          </div>

          <Stack spacing={0.25}>
            <Text setting="title-xsmall">{headlineText}</Text>
            <Text setting="body-small">{bodyText}</Text>
            <StyleQuizModal />
          </Stack>
        </Inline>
      </Box>
    </div>
  );
};

export default NewEntryPoints;
